import { useDetailApi } from "../../../swr/useApi";
import { productRequestsService } from "../../api_client";
import type { ProductRequestDto } from "../../../api";

export function useProductRequestDetails(id?: string | null) {
    return useDetailApi<ProductRequestDto>({
        key: id ? `product-request-details-${id}` : null,
        serviceMethod: async () => await productRequestsService.getProductRequestById(id ?? ""),
    });
}
